import { Button, Dialog, DialogActions, DialogTitle, Grid, Typography } from '@material-ui/core'
import IconCancel from '@material-ui/icons/Cancel'
import { withStyles } from '@material-ui/styles'
import { useState } from 'react'
import { FormWithRedirect, useGetIdentity, useNotify } from 'react-admin'

import { deleteNote } from 'api/notes'
import { captureExceptionIfProduction } from 'helpers/utils'
import { getFormattedDate, getUsernameFromEmail } from '../../helpers/utils'

const styles: any = {
  secondaryTypography: {
    color: '#555962',
    fontWeight: 400,
  },
  noteContent: {
    position: 'relative',
    '&:hover': {
      '& .actions': {
        display: 'block',
      },
    },
  },
  noteTypography: {
    whiteSpace: 'pre-line',
    overflow: 'hidden',
    overflowWrap: 'anywhere',
  },
  actions: {
    position: 'absolute',
    right: 0,
    width: '130px',
    display: 'none',
    boxShadow: '0px 2px 4px 0px #00000030',
  },
  noteBorder: {
    padding: '16px 0 16px 0',
    borderBottom: '1px solid #E5E5E5',
    width: '100%',
  },
  actionButton: {
    color: '#0000ee',
    padding: '4px',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}

const ConfirmDeleteModal = ({ handleConfirm, handleClose, showDialog, loading }: any) => {
  return (
    <Dialog fullWidth open={showDialog} onClose={handleClose} aria-label="Note Modal">
      <DialogTitle>Confirm Delete Note</DialogTitle>
      <FormWithRedirect
        resource="notes"
        render={() => (
          <>
            <DialogActions>
              <Button onClick={handleClose} disabled={loading}>
                <IconCancel />
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={handleConfirm}
                disabled={loading}
              >
                Confirm Delete
              </Button>
            </DialogActions>
          </>
        )}
      />
    </Dialog>
  )
}

const Note = ({
  classes,
  note,
  handleEditModalOpen,
  parentName,
  parentId,
  setNotesList,
  fetchNotesApi,
}: any) => {
  const { identity, loading: identityLoading } = useGetIdentity()

  /** state related to add/edit note modal */
  const [showDialog, setShowDialog] = useState(false)
  const [loadingDialog, setLoadingDialog] = useState(false)
  const handleModalOpen = () => setShowDialog(true)
  const handleModalClose = () => setShowDialog(false)

  const notify = useNotify()
  const handleModalConfirm = () => {
    setLoadingDialog(true)

    deleteNote(parentName, parentId, note.id)
      .then(() => fetchNotesApi(parentName, parentId))
      .then((notesList) => {
        setNotesList(notesList?.results ? notesList.results : notesList)
        setLoadingDialog(false)
        handleModalClose()
        notify('Note deleted!', { type: 'info' })
      })
      .catch((error: any) => {
        setLoadingDialog(false)
        handleModalClose()
        notify(error.message, { type: 'error' })
        captureExceptionIfProduction(error)
      })
  }

  return (
    <Grid className={classes.noteBorder} item style={{}}>
      <Grid item container direction="row" justifyContent="space-between">
        <Typography className={classes.secondaryTypography} component="span" variant="caption">
          {getUsernameFromEmail(note.created_by)}
        </Typography>
        <Typography className={classes.secondaryTypography} component="span" variant="caption">
          {getFormattedDate(note.date_created)}
        </Typography>
      </Grid>
      <Grid item container className={classes.noteContent}>
        <Typography className={classes.noteTypography} variant="body1">
          {note.text}
        </Typography>
        {!identityLoading && note.created_by && identity?.id === note.created_by.id && (
          <Grid item container direction="row" className={classes.actions + ' actions'}>
            <ConfirmDeleteModal
              handleConfirm={handleModalConfirm}
              handleClose={handleModalClose}
              loading={loadingDialog}
              showDialog={showDialog}
            />
            <Button className={classes.actionButton} variant="text" color="primary" onClick={handleModalOpen}>
              Delete
            </Button>
            <Button
              className={classes.actionButton}
              variant="text"
              color="primary"
              onClick={() => handleEditModalOpen(note)}
            >
              Edit
            </Button>
          </Grid>
        )}
      </Grid>
      {note.is_edited && (
        <Grid item>
          <Typography className={classes.secondaryTypography} component="span" variant="caption">
            (edited)
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default withStyles(styles)(Note)
